<p class="section-description">
  The app-wide notice banner shown above the account navigation. Pick a banner to preview each variant and state.
</p>

<label class="recovery-screen-picker">
  <span class="recovery-screen-picker-label">Banner</span>
  <select class="arpio-select" (change)="setBannerScenario($any($event.target).value)">
    @for (scenario of bannerScenarios; track scenario.key) {
      <option [value]="scenario.key" [selected]="scenario.key === bannerScenarioKey">{{ scenario.label }}</option>
    }
  </select>
</label>

<div class="banner-preview">
  <!-- Banner sits flush at the top and stays interactive (dismiss works, action is
       inert); only the overview backdrop below it is frozen. -->
  @if (activeScenario.key !== 'none' && !bannerPreviewDismissed) {
    <app-banner
      [variant]="activeScenario.variant"
      [dismissible]="activeScenario.dismissible"
      (dismissed)="dismissBannerPreview()"
    >
      @if (activeScenario.html) {
        <span [innerHtml]="activeScenario.html"></span>
      } @else {
        <b>{{ activeScenario.lead }}</b> {{ activeScenario.detail }}
      }
      <!-- [hidden], not @if: ng-content select can't match through a control-flow
           block, so the action link must always exist as a static child. -->
      <a banner-action href="javascript:void(0)" role="button" [hidden]="!activeScenario.actionText">
        {{ activeScenario.actionText }}
        <svg lucideChevronRight></svg>
      </a>
    </app-banner>
  }

  <showcase-screen-preview
    [flags]="bgScenario.tabBarFlags"
    activeTab="recovery"
    ariaLabel="Application overview (read-only)"
    [frameless]="true"
  >
    <showcase-status-bar [status]="bgScenario.status"></showcase-status-bar>
    <app-resources-view
      [resources]="bgScenario.resources"
      [tabType]="RECOVERY_SCREEN_TABS.recovery"
      [application]="bgScenario.application"
      [loading]="false"
      [statusContext]="StatusContext.RECOVERY"
    ></app-resources-view>
  </showcase-screen-preview>
</div>
